'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

var _metrics = require('./metrics.scss');

var _metrics2 = _interopRequireDefault(_metrics);

var _routerHistory = require('../../../../../router-history');

var _routerHistory2 = _interopRequireDefault(_routerHistory);

var _events = require('ifeis-isomorphic/lib/redux/actions/events');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MetricsController = function () {
  function MetricsController($state, $scope, $ngRedux, fRouterHistoryService, msgService, feis) {
    var _this = this;

    _classCallCheck(this, MetricsController);

    this.feis = feis;
    this._svc = {
      $state: $state, fRouterHistoryService: fRouterHistoryService, msgService: msgService
    };
    this.eventsHistoryData = {};
    this.filter = '';
    this.eventKeys = [];

    $ngRedux.dispatch((0, _events.getEventsHistory)(feis.id)).then(function (response) {
      _this.eventKeys = Object.keys(response.payload);
      Object.keys(response.payload).forEach(function (key) {
        response.payload[key].eventHistoryCollection.sort(function (a, b) {
          return a.created_at - b.created_at;
        }).forEach(function (event, index) {
          if (index > 0) {
            if (event.created_at && response.payload[key].eventHistoryCollection[index - 1].created_at) {
              event.diff = event.created_at - response.payload[key].eventHistoryCollection[index - 1].created_at;
            } else {
              event.diff = 'Didnot have enough data to calc diff';
            }
          } else {
            event.diff = 'N/A';
          }
        });
      });
      _this.eventsHistoryData = response.payload;
    });
  }

  _createClass(MetricsController, [{
    key: 'back',
    value: function back() {
      this._.fRouterHistoryService.back();
    }
  }, {
    key: 'getAbsoluteValue',
    value: function getAbsoluteValue(diff) {
      if (isNaN(parseInt(diff))) {
        return diff;
      }
      return (diff / (1000 * 60)).toFixed(2) + ' minutes';
    }
  }]);

  return MetricsController;
}();

exports.default = _angular2.default.module('ifeis.routes.feiseanna.one.admin.metrics', []).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.metrics', {
    url: '/metrics',
    template: require('./tpl.html'),
    controller: MetricsController,
    controllerAs: 'metrics',
    ncyBreadcrumb: {
      label: 'Metrics',
      parent: 'feiseanna.one.admin.manager'
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/metrics/index.js
// module id = 548
// module chunks = 0